<template>
	<div class="settings-container">
		<h1>{{ $t('appbar.settings-menu.Security.title') }}</h1>
		<b-card class="settings-group" :title="$t('appbar.settings-menu.Security.changePassword')">
			<b-form>
				<b-form-group :label="$t('appbar.settings-menu.Security.currentPassword')" label-for="current-password">
					<b-form-input
						id="current-password"
						v-model="currentPassword"
						type="password"
						:placeholder="$t('appbar.settings-menu.Security.currentPasswordPlaceholder')"
					/>
				</b-form-group>
				<b-form-group :label="$t('appbar.settings-menu.Security.newPassword')" label-for="new-password">
					<b-form-input
						id="new-password"
						v-model="newPassword"
						type="password"
						:placeholder="$t('appbar.settings-menu.Security.newPasswordPlaceholder')"
					/>
				</b-form-group>
				<b-form-group :label="$t('appbar.settings-menu.Security.confirm')" label-for="confirm">
					<b-form-input
						id="confirm"
						v-model="confirmNewPassword"
						type="password"
						:placeholder="$t('appbar.settings-menu.Security.confirmPlaceholder')"
					/>
				</b-form-group>
			</b-form>
			<b-button class="submit-button" type="submit" @click="changePassword">
				{{ $t('appbar.settings-menu.Security.changePassword') }}
			</b-button>
		</b-card>
		<b-card class="settings-group" :title="$t('appbar.settings-menu.Security.changeMFA')">
			<b-card-text>{{ $t('appbar.settings-menu.Security.changeMFAParagraph') }}</b-card-text>
			<b-form>
				<VuePhoneNumberInput />
			</b-form>
			<b-button class="submit-button mt-2" type="submit">
				{{ $t('appbar.settings-menu.Security.sendMFA') }}
			</b-button>
		</b-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currentPassword: null,
			newPassword: null,
			confirmNewPassword: null,
		};
	},
	methods: {
		async changePassword() {
			await this.axios
				.post('/account/password', {
					old: this.currentPassword,
					new: this.newPassword,
				})
				.then((response) => {
					if (response.status === 204) {
						this.$bvToast.toast(this.$t('appbar.settings-menu.Security.change-success'), {
							title: this.$t('toast.success'),
							variant: 'success',
						});
					} else {
						this.$bvToast.toast(this.$t('appbar.settings-menu.Security.change-error'), {
							title: this.$t('toast.error'),
							variant: 'danger',
						});
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
	},
};
</script>

<style scoped>
.settings-container {
	flex: 1;
	overflow-y: auto;
	padding: 1rem;
}

.settings-container::after {
	content: '';
	display: block;
	height: 2rem;
	width: 100%;
}

.settings-group {
	margin-top: 1.5rem;
	max-width: 40rem;
}

.submit-button {
	display: block !important;
	margin-right: auto;
	margin-left: auto;
}
</style>